"use client";

interface MatchEndedProps {
  opponentName: string | null;
  onExit: () => void;
}

// Full-screen notice shown when the opponent leaves before the match concludes.
// The run is voided — neither player's score counts — and the player is sent
// back to the landing screen.
export default function MatchEnded({ opponentName, onExit }: MatchEndedProps) {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 px-4 text-center">
      <div className="text-5xl">🏳️</div>
      <h1 className="text-[clamp(1.5rem,4vw,2.5rem)] font-extrabold">
        Match cancelled
      </h1>
      <p className="max-w-md text-white/60">
        {opponentName ? `${opponentName} left the match.` : "Your opponent left the match."}{" "}
        This run has been voided — it won&apos;t be saved or scored.
      </p>
      <button
        onClick={onExit}
        className="rounded-full bg-accent px-8 py-3 text-sm font-bold uppercase tracking-widest text-white shadow-[0_0_30px_rgba(124,58,237,0.5)] transition hover:brightness-110"
      >
        Back to Menu
      </button>
    </main>
  );
}
